function handleChatPopup() {
    const popup = document.querySelector('.tww-chat-popup')
    const isChatOpen = popup.classList.contains('active')
    const openIcon = document.querySelector('.tww-icon-open')
    const closeIcon = document.querySelector('.tww-icon-close')
    
    function openChat() {
        popup.classList.add('active')
        closeIcon.classList.add('active')
        openIcon.classList.remove('active')
    }

    function closeChat() {
        popup.classList.remove('active')
        openIcon.classList.add('active')
        closeIcon.classList.remove('active')
    }

    isChatOpen ? closeChat() : openChat()
}





